import { useDispatch, useSelector } from "react-redux";
import GridTopFiltersZipModal from "../../new_taxonomy/grid-top-filters-zip-modal";
import { refreshGridProducts } from "actions/products-actions";
import PropTypes from "prop-types";
import { closeModal, openZipFilterModal } from "actions/grid-modal-actions";

export default function ZipUpdater({ isGridProductDrawer, saveZipToWorkingFilter }) {
  const dispatch = useDispatch();
  const browser = useSelector(state => state.browser);
  const displayedModal = useSelector(state => state.displayedModal);
  const workingFilters = useSelector(state => state.workingFilters);

  const closeZipFilterModal = () => dispatch(closeModal());

  const onSubmitZip = zipFilter => {
    saveZipToWorkingFilter(zipFilter);
    closeZipFilterModal();

    //If we're viewing product drawer on grid, we also need to reload the grid
    if (isGridProductDrawer) {
      const page = 1;
      dispatch(refreshGridProducts(page));
    }
  };

  const onClickZipCode = e => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(openZipFilterModal());
  };

  return (
    <>
      <div className="my-4">
        Delivery to{" "}
        <button className="underline font-bold" onClick={onClickZipCode}>
          {workingFilters?.zip_code}
        </button>
      </div>

      <GridTopFiltersZipModal
        browser={browser}
        displayedModal={displayedModal}
        onRequestClose={closeZipFilterModal}
        onSubmit={onSubmitZip}
        workingFilters={workingFilters}
        key="gridTopFiltersZipModal"
      />
    </>
  );
}

ZipUpdater.propTypes = {
  isGridProductDrawer: PropTypes.bool,
  saveZipToWorkingFilter: PropTypes.func,
};
